<template>
  <div>
    <div class="manage-header" v-loading="loading" element-loading-text="拼命上传中" element-loading-spinner="el-icon-loading">
      <el-upload
        action="https://jsonplaceholder.typicode.com/posts/"
        :file-list="fileList"
        :before-upload="beforeUpload"
        :limit="1"
        :on-exceed="handleExceed"
        :http-request="getFile"
      >
        <el-button size="small" type="primary">上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
      </el-upload>
      <el-button size="small" type="success" @click="upload">确认上传</el-button>

      <common-form inline :formLabel="formLabel" :form="searchFrom">
        <el-button type="primary" @click="getList(searchFrom.keyword)" icon="el-icon-search">搜索</el-button>
      </common-form>
    </div>
    <contTemp-table :tableData="tableData" :tableLabel="tableLabel" :config="config" @changePage="changePage" @del="delContTamp"></contTemp-table>
  </div>
</template>

<script>
import CommonForm from '../../components/CommonForm'
import ContTempTable from '../../components/ContTempTable'
import { pageContractTempInfoApi } from '../../api/getData'
import axios from '../../api/config'
import { delContTempApi } from '../../api/getData'

export default {
  components: {
    CommonForm,
    ContTempTable
  },
  data() {
    return {
      file: {},
      fileList: [],
      isShow: false,
      tableData: [],
      loading: false,
      currentUser: '',
      tableLabel: [
        {
          prop: 'templateId',
          label: '模板ID',
          width: 280
        },
        {
          prop: 'tempName',
          label: '模板名称',
          width: 300
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: 200
        }
      ],
      header: 'multipart/form-data;charset=utf-8',
      config: {
        page: 1,
        size: 5,
        total: 0,
        loading: true
      },
      searchFrom: {
        keyword: ''
      },
      formLabel: [
        {
          model: 'keyword',
          label: ''
        }
      ]
    }
  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit()
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeUpload(file) {
      console.log(file)
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf'
      if (!extension) {
        this.$message({
          message: '上传文件只能是 pdf 格式!',
          type: 'warning'
        })
      }
      return extension
    },
    getList(val) {
      this.config.loading = true
      // 搜索时，页码需要设置为1，才能正确返回数据，因为数据是从第一页开始返回的
      val ? (this.config.page = 1) : ''

      //调用查询接口
      pageContractTempInfoApi(this.config.page, this.config.size, val, val).then(res => {
        res = res.data
        this.tableData = res.data
        //console.log(res)
        //this.tableData.createTime
        this.config.total = res.total
        this.config.size = res.pageSize
        this.config.loading = false
      })
    },
    changePage(val) {
      this.config.page = val
      this.getList()
    },
    getFile(item) {
      this.file = item.file
    },
    delContTamp(row) {
      this.$confirm('此操作将删除该模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delContTempApi(row.templateId).then(res => {
            console.log(res.data)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    upload() {
      this.loading = true
      const file = new FormData()
      file.append('filename', this.file)
      //console.log(this.currentUser)
      const headConfig = { headers: { 'Content-Type': 'multipart/form-data' } }
      //该处没有使用统一接口管理getData.js，是因为getData.js中单独设置headers存在跨域问题,原因不明
      axios.post('http://localhost:8081/api/v2/pri/contTemp/uploadTemp', file, headConfig).then(res => {
        //console.info(res)
        if (res.data.code === 0) {
          console.info(res.data)
          //this.$router.go(0) //刷新页面
          this.$message({
            type: 'success',
            message: '模板上传成功!'
          })
          this.getList()
        } else {
          alert(res.data.msg)
        }
        this.clearFile() //清空文件列表
        this.loading = false
      })
    },
    //清空file
    clearFile() {
      this.fileList = []
      this.file = {}
    }
  },
  created() {
    this.getList()
    //console.log(store.state.user.mobile)
    this.currentUser = window.localStorage.getItem('mobile')
  }
}
</script>

<style lang="scss" scoped>
.manage-header {
  display: flex;
  justify-content: space-between; /*水平排布方式*/
}
</style>
